import { __extends } from "tslib";
// PO31A
import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { compose } from 'redux';
import IconPlay from '../../../Icons/Play';
import Logo from '../../../Logo';
import Popup from '../../../Popup';
import VideoPopup from '../../Video';
import { FirstTimeFlag, } from '../../../redux/firstTimeFlags';
import reduxContainer from './EclipseWelcome.container';
import s from './EclipseWelcome.scss';
var defaultState = {
    showVideoPopup: false,
};
var enhance = compose(reduxContainer, withTranslation());
var EclipseWelcome = /** @class */ (function (_super) {
    __extends(EclipseWelcome, _super);
    function EclipseWelcome() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = defaultState;
        _this.dropFirstTimeFlag = function () {
            _this.props.dropFirstTimeFlag &&
                _this.props.dropFirstTimeFlag({
                    flag: FirstTimeFlag.WelcomePopupNotClosed,
                });
        };
        _this.dropFirstTimeFlagAndNavigateToBrowse = function () {
            _this.props.dropFirstTimeFlag &&
                _this.props.dropFirstTimeFlag({
                    flag: FirstTimeFlag.WelcomePopupNotClosed,
                    redirectTo: Url.browseHomeLink(),
                });
        };
        _this.showVideoPopup = function () {
            _this.setState({ showVideoPopup: true });
        };
        _this.hideVideoPopup = function () {
            _this.setState({ showVideoPopup: false });
        };
        return _this;
    }
    EclipseWelcome.prototype.render = function () {
        if (this.state.showVideoPopup) {
            return this.renderVideoPopup();
        }
        return this.renderMainPopup();
    };
    EclipseWelcome.prototype.renderMainPopup = function () {
        var t = this.props.t;
        return (React.createElement(Popup, { isOpen: true, onRequestClose: this.dropFirstTimeFlag, className: s['eclipse-welcome'] },
            React.createElement("h1", { className: s['title'] }, t('welcomePopup.newUsers.revised.title')),
            React.createElement("p", { className: s['body'] },
                React.createElement(Trans, { i18nKey: 'welcomePopup.newUsers.revised.body' },
                    "We\u2019ve made some bold changes to enhance your experience. To get started on your deviant journey,",
                    React.createElement("button", { className: s['video-link'], onClick: this.showVideoPopup }, "check out the video"),
                    " to find out what\u2019s new.")),
            React.createElement("button", { className: s['video'], onClick: this.showVideoPopup },
                React.createElement(IconPlay, { className: s['icon-play'] })),
            React.createElement("p", { className: s['learn-more'] },
                React.createElement(Trans, { i18nKey: 'welcomePopup.newUsers.revised.learnMore' },
                    React.createElement("a", { href: 'https://www.deviantart.com/team/journal/DeviantArt-Eclipse-is-Here-814629875', className: s['learn-more-link'] }, "Learn more"),
                    "about the new version of DeviantArt!")),
            React.createElement("a", { className: s['artist-credit'], href: Url.userLink('ellysiumn') },
                React.createElement(Trans, { i18nKey: 'welcomePopup.newUsers.revised.artistCredit' },
                    "Art by ",
                    React.createElement("em", { className: s['artist-name'] }, "ellysiumn"))),
            React.createElement(Logo, { className: s['logo'], size: "tiny", markColor: "white", textColor: "white" })));
    };
    EclipseWelcome.prototype.renderVideoPopup = function () {
        return (React.createElement(VideoPopup, { onRequestClose: this.hideVideoPopup, source: "//film00.deviantart.net/27fe/v/mp4/2019/269/0/e/thenewdeviantart_marketing2_smal_by_dnlv3-ddh0vy9.mp4", posterFrame: "//other00.deviantart.net/f598/o/2019/269/d/4/d48ccaf486504ebb2be4703accd4a5c0.jpg", autoPlay: true }));
    };
    return EclipseWelcome;
}(React.Component));
export { EclipseWelcome };
export default enhance(EclipseWelcome);
//# sourceMappingURL=EclipseWelcome.js.map